// extracted by mini-css-extract-plugin
export default {"root":"MappingInformation_root__re8eo","header":"MappingInformation_header__L+M+S","description":"MappingInformation_description__eural","link":"MappingInformation_link__SbWdN"};